import carousel_module_default from "./carousel.module.js";
import { jsx } from "react/jsx-runtime";
import { Carousel } from "@mantine/carousel";
import "@mantine/carousel/styles.css";

//#region src/components/carousel/Carousel.tsx
/**
* A dynamic display of multiple items, which users can navigate through
*/
const Carousel$1 = ({ slides, withIndicators = true, withControls = false, cropped = true, indicatorOffset, onNextSlide, onPreviousSlide, onSlideChange, "data-testid": testId }) => {
	const vars = {};
	if (indicatorOffset) vars["--indicator-offset"] = indicatorOffset;
	return /* @__PURE__ */ jsx(Carousel, {
		slideSize: cropped ? "85%" : void 0,
		slideGap: "sm",
		withIndicators,
		withControls,
		classNames: carousel_module_default,
		onNextSlide,
		onPreviousSlide,
		onSlideChange,
		__vars: vars,
		emblaOptions: { align: "start" },
		role: "tablist",
		"data-testid": testId,
		children: slides.length ? slides.map((content, idx) => /* @__PURE__ */ jsx(Carousel.Slide, { children: content }, `carousel-slide-${idx}`)) : null
	});
};

//#endregion
export { Carousel$1 as Carousel };